/**
 * @generated SignedSource<<1e40fdc5c44cf26246a619cfb9e812f3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type taskList_viewer$data = {
  readonly availableFeatureFlags: ReadonlyArray<{
    readonly key: string | null;
  } | null> | null;
  readonly tasks: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly highLowSuggestion?: {
          readonly high: number | null;
          readonly low: number | null;
          readonly estimate: number | null;
        } | null;
        readonly roleSuggestion?: ReadonlyArray<string | null> | null;
        readonly assigneeSuggestion?: ReadonlyArray<string | null> | null;
        readonly labelSuggestion?: ReadonlyArray<string | null> | null;
      } | null;
    } | null> | null;
  } | null;
  readonly " $fragmentType": "taskList_viewer";
};
export type taskList_viewer$key = {
  readonly " $data"?: taskList_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"taskList_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "fetchAssignee"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "fetchHighLow"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "fetchLabels"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "fetchRoles"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "taskIds"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "taskList_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "FeatureFlag",
      "kind": "LinkedField",
      "name": "availableFeatureFlags",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "key",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 10000
        },
        {
          "kind": "Variable",
          "name": "taskIds",
          "variableName": "taskIds"
        }
      ],
      "concreteType": "TaskTypeConnection",
      "kind": "LinkedField",
      "name": "tasks",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "TaskTypeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Task",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                {
                  "condition": "fetchHighLow",
                  "kind": "Condition",
                  "passingValue": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "HighLowSuggestions",
                      "kind": "LinkedField",
                      "name": "highLowSuggestion",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "high",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "low",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "estimate",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ]
                },
                {
                  "condition": "fetchRoles",
                  "kind": "Condition",
                  "passingValue": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "roleSuggestion",
                      "storageKey": null
                    }
                  ]
                },
                {
                  "condition": "fetchAssignee",
                  "kind": "Condition",
                  "passingValue": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "assigneeSuggestion",
                      "storageKey": null
                    }
                  ]
                },
                {
                  "condition": "fetchLabels",
                  "kind": "Condition",
                  "passingValue": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "labelSuggestion",
                      "storageKey": null
                    }
                  ]
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "8dbfad1ae264160932b87293927c2c00";

export default node;
